import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { RECOMMNDATION_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";

const SLICE = "ManageSuggestions";

const initialState: any = {
  suggestions: [],
  totalSuggestions: 0,
  suggestionsLoader: false,
  selectedSuggestedInncodes: [],
  isAssignmentPopupOpen: false,
  isAllSelected: false,
  staticListId: null,
  suggestedByDetails: [],
  payloadData: {
    plans: []
  },
  isErrorWhenLimitExceed: false,
  allSuggestedInncodes: []
};

export const fetchSuggestionsAsync = createAsyncThunk(`${SLICE}/fetchSuggestionsAsync`, (data: any, thunkApi) =>
  apiRequest(RECOMMNDATION_SERVICE_METHOD.postSuggestions, data, thunkApi)
);

export const postSuggestedPlansAsync = createAsyncThunk(`${SLICE}/postSuggestedPlansAsync`, (data: any, thunkApi) =>
  apiRequest(RECOMMNDATION_SERVICE_METHOD.postSuggestedPlans, data, thunkApi)
);

export const fetchSuggestionsDetailsAsync = createAsyncThunk(
  `${SLICE}/fetchSuggestionsDetailsAsync`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.postSuggestions, data, thunkApi)
);

export const uploadRecommendationsAsync = createAsyncThunk(
  `${SLICE}/uploadRecommendationsAsync`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.fileUpload, data, thunkApi)
);

export const uploadMatricsAsync = createAsyncThunk(`${SLICE}/uploadMatricsAsync`, (data: any, thunkApi) =>
  apiRequest(RECOMMNDATION_SERVICE_METHOD.fileUploadMatrics, data, thunkApi)
);

export const fetchSuggestedByDetailsAsync = createAsyncThunk(
  `${SLICE}/fetchSuggestedByDetailsAsync`,
  (data: any, thunkApi) => apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data)
);

export const deleteSuggestionAsync = createAsyncThunk(`${SLICE}/deleteSuggestionAsync`, (data: any, thunkApi) =>
  apiRequest(RECOMMNDATION_SERVICE_METHOD.deleteSuggestedPlans, null, thunkApi, [], null, data)
);

export const fetchAllSuggestedInncodesAsync = createAsyncThunk(
  `${SLICE}/fetchSelectedSuggestedInncodesAsync`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.postSuggestions, data, thunkApi)
);

export const ManageSuggestionsSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => initialState,
    setSelectedSuggestedInncodes: (state, action) => {
      state.selectedSuggestedInncodes = action.payload;
    },
    setAssignmentPopupOpen: (state, action) => {
      state.isAssignmentPopupOpen = action.payload;
    },
    setIsAllSelected: (state, action) => {
      state.isAllSelected = action.payload;
    },
    setStaticListId: (state, action) => {
      state.staticListId = action.payload;
    },
    setPayloadData: (state, action) => {
      state.payloadData = {
        ...state.payloadData,
        ...action.payload
      };
    },
    resetPayloadData: (state) => {
      state.payloadData.plans = [];
    },
    setIsErrorWhenLimitExceed: (state, action) => {
      state.isErrorWhenLimitExceed = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestionsAsync.pending, (state, action: any) => {
        state.suggestionsLoader = action.meta.arg.pageable.page === 0;
      })
      .addCase(fetchSuggestionsAsync.fulfilled, (state, action: any) => {
        state.suggestions =
          action.meta.arg.pageable.page === 0
            ? action.payload.suggestions
            : [...state.suggestions, ...action.payload.suggestions];
        state.totalSuggestions = action.payload.meta.page.total;
        state.suggestionsLoader = false;
      })
      .addCase(uploadRecommendationsAsync.fulfilled, (state) => {
        state.suggestionsLoader = false;
      })
      .addCase(uploadMatricsAsync.fulfilled, (state) => {
        state.suggestionsLoader = false;
      })
      .addCase(postSuggestedPlansAsync.fulfilled, (state, action: any) => {
        state.isAssignmentPopupOpen = false;
        state.suggestionsLoader = false;
      })
      .addCase(fetchSuggestedByDetailsAsync.fulfilled, (state, action) => {
        state.suggestedByDetails = action.payload.users;
        state.suggestionsLoader = false;
      })
      .addCase(fetchAllSuggestedInncodesAsync.fulfilled, (state, action) => {
        state.allSuggestedInncodes = action.payload.meta.inncodes;
      })
      .addMatcher(isFulfilled(fetchSuggestionsDetailsAsync, deleteSuggestionAsync), (state, action: any) => {
        const data = [...state.suggestions];
        const detailList = action?.payload?.suggestions?.[0];
        const suggestionsList = data?.map((el: any) => {
          if (el.inncode === detailList?.inncode) {
            el = {
              ...el,
              history: detailList?.plans,
              suggestedPlansCount: detailList.suggestedPlansCount
            };
            return el;
          } else {
            return el;
          }
        });
        state.suggestions = suggestionsList;
        state.suggestionsLoader = false;
      })
      .addMatcher(
        isPending(
          fetchSuggestionsDetailsAsync,
          uploadRecommendationsAsync,
          uploadMatricsAsync,
          postSuggestedPlansAsync,
          deleteSuggestionAsync
        ),
        (state) => {
          state.suggestionsLoader = true;
        }
      )
      .addMatcher(
        isRejected(
          fetchSuggestionsAsync,
          fetchSuggestionsDetailsAsync,
          uploadRecommendationsAsync,
          uploadMatricsAsync,
          fetchSuggestedByDetailsAsync,
          postSuggestedPlansAsync,
          deleteSuggestionAsync
        ),
        (state) => {
          state.suggestionsLoader = false;
        }
      );
  }
});

export const {
  setSelectedSuggestedInncodes,
  setIsAllSelected,
  setAssignmentPopupOpen,
  setStaticListId,
  setPayloadData,
  reset,
  setIsErrorWhenLimitExceed,
  resetPayloadData
} = ManageSuggestionsSlice.actions;

export default ManageSuggestionsSlice.reducer;
